let tempSampleIdCounter = 0;
function makeTempSampleId() {
    return `temp-${Date.now()}-${tempSampleIdCounter++}`;
}

function buildTempSamples(state, group, count = 1, template = null) {
    const baseTemplate = template || {};
    const samples = [];

    const fieldsForType = state.sample_type_fields[group.sample_type_id] || {};
    const parentFields = (fieldsForType.sample && fieldsForType.sample.other) || [];
    const childFields = fieldsForType.child_sample || [];

    for (let i = 0; i < count; i++) {
        const isChild = !!(baseTemplate.parent_analysis_sample_id || (template && template.parent_analysis_sample_id));
        const fieldsForSample = isChild ? childFields : parentFields;

        const details = Array.isArray(baseTemplate.details)
            ? JSON.parse(JSON.stringify(baseTemplate.details))
            : [];

        const existingKeys = new Set(details.map(d => d.field_key.toString()));

        fieldsForSample.forEach(field => {
            if (!existingKeys.has(field.fieldNumber.toString())) {
                details.push({
                    field_key: field.fieldNumber,
                    field_value: null,
                    missing: true,
                });
            }
        });

        if (!details.some(d => d.field_key === 'tests')) {
            details.push({
                field_key: 'tests',
                field_value: '',
                missing: true,
            });
        }

        // Soil default: depth = "0-"
        if (group.sample_type_id == 2223) {
            let depthDetail = details.find(d => d.field_key === 'depth');
            if (!depthDetail) {
                depthDetail = {
                    field_key: 'depth',
                    field_value: '0-',
                    missing: false,
                };
                details.push(depthDetail);
            } else if (!depthDetail.field_value) {
                depthDetail.field_value = '0-';
                depthDetail.missing = false;
            }
        }

        samples.push({
            client_id: makeTempSampleId(),
            analysis_sample_id: null,
            analysis_sample_group_id: group.analysis_sample_group_id,
            parent_analysis_sample_id: baseTemplate.parent_analysis_sample_id || null,
            customer_sample_id: baseTemplate.customer_sample_id || '',
            soilrecs: baseTemplate.soilrecs ? JSON.parse(JSON.stringify(baseTemplate.soilrecs)) : [],
            details,
            selected: false,
            saving: true,
            valid: false,
        });
    }

    return samples;
}

let actions = {
    addImportsToSampleGroup({ commit }, params) {
        commit('ADD_IMPORTS_TO_SAMPLE_GROUP', params);
    },
    addSampleGroup({ commit }, params) {
        commit('ADD_SAMPLE_GROUP', params);
    },
    async addSamplesToGroup({ state, commit }, { group, count, template, onSuccess, skip_temp }) {
        if (skip_temp) {
            commit('PENDING_SAMPLE_OPS', 1);
            try {
                const response = await axios.post(
                    '/analysis/' + state.draft.analysis_order_id + '/groups/' + group.analysis_sample_group_id + '/samples',
                    { count, template: template || null }
                );
                if (response.data && typeof onSuccess === 'function') onSuccess();
            } catch (error) {
                throw error;
            } finally {
                commit('PENDING_SAMPLE_OPS', -1);
            }
            return;
        }

        const tempSamples = buildTempSamples(state, group, count || 1, template);
        commit('ADD_TEMP_SAMPLES_TO_GROUP', { group, tempSamples });

        commit('PENDING_SAMPLE_OPS', 1);
        try {
            const response = await axios.post(
                `/analysis/${state.draft.analysis_order_id}/groups/${group.analysis_sample_group_id}/samples`,
                {
                    count,
                    template: template ? template : null
                }
            );

            if (response.data) {
                commit('REPLACE_TEMP_SAMPLES_WITH_REAL', {
                    group,
                    tempSamples,
                    new_samples: response.data
                });

                if (typeof onSuccess === 'function') onSuccess();
            } else {
                commit('REMOVE_TEMP_SAMPLES_FROM_GROUP', { group, tempSamples });
            }
        } catch (error) {
            commit('REMOVE_TEMP_SAMPLES_FROM_GROUP', { group, tempSamples });
            throw error;
        } finally {
            commit('PENDING_SAMPLE_OPS', -1);
        }
    },

    async fetchGroupSamplesPage({ state, commit }, { group, page, per_page }) {
        commit('PENDING_SAMPLE_OPS', 1);
        try {
            const response = await axios.get(
                '/analysis/' + state.draft.analysis_order_id + '/groups/' + group.analysis_sample_group_id + '/samples/page',
                { params: { page: page || 1, per_page: per_page || 25 } }
            );
            if (response.data) {
                commit('SET_GROUP_SAMPLES_PAGE', {
                    group,
                    samples: response.data.samples,
                    samples_meta: response.data.samples_meta,
                });
            }
        } catch (error) {
            if (window.toastr) toastr.error('There was a problem loading the samples. Please try again.');
            throw error;
        } finally {
            commit('PENDING_SAMPLE_OPS', -1);
        }
    },

    async addMultipleSamplesToGroup({ state, commit }, { group, samples, onSuccess }) {
        commit('PENDING_SAMPLE_OPS', 1);

        try {
            const response = await axios.post(
                `/analysis/${state.draft.analysis_order_id}/groups/${group.analysis_sample_group_id}/samples`,
                { samples }
            );

            if (response.data) {
                commit('ADD_SAMPLES_TO_GROUP', { group, new_samples: response.data });

                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        } catch (error) {
            throw error;
        } finally {
            commit('PENDING_SAMPLE_OPS', -1);
        }
    },
    changeScreenLayout({ commit }, layout) {
        commit('CHANGE_SCREEN_LAYOUT', layout);
    },
    copyDown({ commit }) {

    },
    deleteItemKey({ commit }, params) {
        commit('DELETE_ITEM_KEY', params);
    },
    dismissError({ state, commit }, index) {
        if (_.has(state.errors, index)) {
            commit('DISMISS_ERROR', index)
        }
    },
    getSoilCropData({ commit }) {
        commit('GET_SOIL_CROP_DATA');
    },
    initializeTestDetailsModal({ commit }, el) {
        commit('INITIALIZE_TEST_DETAILS_MODAL', el);
    },
    loadSampleTypeFields({ commit }, sample_type_id) {
        commit('LOAD_SAMPLE_TYPE_FIELDS', sample_type_id)
    },
    loadSampleTypeTests({ commit }, sample_type_id) {
        commit('LOAD_SAMPLE_TYPE_TESTS', sample_type_id)
    },
    loadSampleTypeGroupDetailsSuggestions({ commit }, sample_type_id) {
        commit('LOAD_SAMPLE_TYPE_GROUP_DETAILS_SUGGESTIONS', sample_type_id)
    },
    removeItemFromArray({ commit }, params) {
        commit('REMOVE_ITEM_FROM_ARRAY', params);
    },
    removeSampleGroup({ commit }, group) {
        commit('REMOVE_SAMPLE_GROUP', group);
    },
    async removeSamplesFromGroup({ state, commit }, { group, analysis_sample_ids }) {
        if (!Array.isArray(analysis_sample_ids) || analysis_sample_ids.length === 0) return;

        commit('PENDING_SAMPLE_OPS', 1);
        try {
            await axios.delete(
                `/analysis/${state.draft.analysis_order_id}/groups/${group.analysis_sample_group_id}/samples`,
                { data: { analysis_sample_ids } }
            );

            commit('REMOVE_SAMPLES_FROM_GROUP', { group, analysis_sample_ids });
        } finally {
            commit('PENDING_SAMPLE_OPS', -1);
        }
    },
    removeSoilRecRequest({ commit, dispatch }, params) {
        commit('REMOVE_SOIL_REC', params);
        dispatch('saveSampleRequest', params.sample);
    },
    saveDraftOrderRequest({ state }) {
        const { draft } = state;
        const { analysis_order_id } = draft;

        return axios.put(`/analysis/${analysis_order_id}`, {
            ...draft
        })
    },
    saveGroupSamplesRequest({ state }, group) {
        const { draft } = state;
        const { analysis_order_id } = draft;
        const { analysis_sample_group_id, samples } = group;

        return axios.put(`/analysis/${analysis_order_id}/groups/${analysis_sample_group_id}/samples`, {
            samples
        })
    },
    saveGroupDetailsRequest({ state }, group) {
        if (!group || !group.analysis_sample_group_id) return;

        axios.put('/analysis/' + state.draft.analysis_order_id + '/groups/' + group.analysis_sample_group_id, group);
    },
    saveOrderDetailsRequest({ commit }) {
        commit('SAVE_ORDER_DETAILS');
    },
    saveSampleRequest({ state }, sample) {
        if (!sample || !sample.analysis_sample_id) return;
        axios.put(`/analysis/${state.draft.analysis_order_id}/groups/${sample.analysis_sample_group_id}/samples/${sample.analysis_sample_id}`, sample);
    },
    setAccount({ commit, dispatch }, account) {
        commit('SET_ACCOUNT', account);
        dispatch('retrieveDraftOrder');
        commit('LOAD_SAMPLE_TYPE_GROUPS');
    },
    updateLoading({ commit }, loading) {
        commit('UPDATE_LOADING', loading);
    },
    updateUnavailableTests({ commit, dispatch }, { group, unavailable_tests }) {
        commit('UPDATE_UNAVAILABLE_TESTS', { group, unavailable_tests });
        dispatch('saveGroupDetailsRequest', group);
    },
    async retrieveDraftOrder({ commit, state }) {
        const { account, loading } = state;

        if (_.has(account, 'account_nbr') && !loading.draft_order) {
            commit('UPDATE_DRAFT_ORDER', {});

            await axios.get('/analysis/load-draft', {
                params: {
                    account_number: account.account_nbr
                }
            })
                .then((response) => {
                    if (response.data) {
                        commit('UPDATE_DRAFT_ORDER', response.data);
                    }
                });
        }
    },
    setItemValue({ commit }, params = {}) {
        commit('SET_ITEM_VALUE', params)
    },
    setUser({ commit, dispatch }, user) {
        commit('SET_USER', user);
        dispatch('retrieveDraftOrder');
    },
    showTestDetails({ commit }, { sample_type, test }) {
        commit('SHOW_TEST_DETAILS', { sample_type, test });
    },
    submitOrder({ commit }) {
        commit('SUBMIT_DRAFT_ORDER');
    },
    updateAvailableCrops({ commit }, available_crops) {
        commit('UPDATE_AVAILABLE_CROPS', available_crops);
    },
    updateImportFile({ commit }, import_file) {
        commit('UPDATE_IMPORT_FILE', import_file);
    },
    updateSoilRecs({ commit, dispatch }, params = {}) {
        if (!params.sample || !params.recs) return;

        const soilrecs = params.recs.map((rec, i) => {
            let soilrec = (_.has(params.sample, ['soilrecs', i])) ? JSON.parse(JSON.stringify(params.sample.soilrecs[i])) : {};

            soilrec.crop_id = rec.crop_id;
            soilrec.yield = rec.yield;
            soilrec.previous_crop_id = rec.previous_crop_id;

            return soilrec;
        });

        if (JSON.stringify(soilrecs) !== JSON.stringify(params.sample.soilrecs)) {
            commit('SET_ITEM_VALUE', {
                item: params.sample,
                key: 'soilrecs',
                value: soilrecs
            });

            dispatch('saveSampleRequest', params.sample);
        }
    },
    updateUserBilling({ commit }, can_see) {
        commit('UPDATE_USER_BILLING', can_see);
    },
    loadTestBlacklist({ commit }) {
        commit('LOAD_TEST_BLACKLIST');
    },
};

export default actions;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/analysis/actions.js